import { makeVar, useReactiveVar } from '@apollo/client';

export const activePrintFiltersVar = makeVar<Set<string>>(new Set());

export const useActivePrintFiltersVar = () => {
  return useReactiveVar(activePrintFiltersVar);
};
